import { Flex } from 'antd'

import { ArithmeticOperation, JtfMode, ModuleInfo } from '@suntex.fim/enums'
import { useModuleById } from '@suntex.fim/framework'
import { ModuleLayout } from '@suntex.fim/modules'
import { usePlayerDashboardPath } from '@suntex.fim/nav'
import { usePlayer } from '@suntex.fim/player'
import { Button } from '@suntex.fim/ui'

import { fimCdnAnimateUrl, justTheFactsModuleId } from '../../../utils/fimUtils'
import Canvas, { CanvasProperties, ICanvasParameters } from '../Shared/Canvas'

import { Loading } from './Module'
import { startOnKeyDown } from './justTheFactsKeyboard'

export interface IJustTheFactsProps {
  jtfMode: JtfMode
  arithmeticOperation: ArithmeticOperation
}

export function JustTheFacts({
  jtfMode,
  arithmeticOperation
}: IJustTheFactsProps) {
  const moduleId = justTheFactsModuleId(jtfMode, arithmeticOperation)
  const module = useModuleById(moduleId)
  const { playerId, isPreview } = usePlayer()
  const hubUrl = usePlayerDashboardPath()
  if (!module) return <Loading />

  //        "images": { },`
  //        "compositionId": "",
  //        "isResponsiveCompatible": false,
  //        "autoLoadView": true,
  //        "preview": false,
  //        "pwaMode": false,
  //        "mute": false,
  //    IsResponsiveCompatible = Model.Module.IsResponsive
  //    canvas.Parameters("pwaMode") = Model.PWAMode

  interface IJustTheFactsCanvasParameters extends ICanvasParameters {
    playerId: number
    moduleId: number
    imageDirectory: string
    soundDirectory: string
  }

  const propsCanvas = new CanvasProperties<IJustTheFactsCanvasParameters>()

  propsCanvas.name = 'JustTheFacts'
  propsCanvas.width = 800
  propsCanvas.height = 600
  propsCanvas.jsSrc = 'JustTheFacts.js'
  propsCanvas.preview = isPreview
  propsCanvas.bgColor = '#ffffff'

  propsCanvas.parameters.playerId = playerId
  propsCanvas.parameters.moduleId = moduleId
  propsCanvas.parameters.imageDirectory = fimCdnAnimateUrl('/images/')
  propsCanvas.parameters.soundDirectory = fimCdnAnimateUrl('/sounds/')

  //propsCanvas.parameters.nextGameUrl = Model.NextGameUrl
  propsCanvas.parameters.hubUrl = hubUrl

  //FIM 1.0 has this:
  //model.Round = AppQueryString.r
  //propsCanvas.parameters("pwaMode") = Model.PWAMode

  //function glossary() {
  //  console.log('glossary')
  //}

  return (
    <ModuleLayout moduleId={moduleId} isLegacyModule>
      <div>
        <Canvas
          {...propsCanvas}
          label="Just the Facts. Press Enter to start, then type each answer and press Enter."
          onCanvasKeyDown={startOnKeyDown}
        />

        {moduleId === ModuleInfo.ss_5_1 && (
          <p style={{ textAlign: 'right' }}>
            <Button
              onClick={() => window.open('/explore/popups/fractions-glossary')}
            >
              fractions glossary
            </Button>
          </p>
        )}

        <Flex
          gap={4}
          align="center"
          vertical
          justify="center"
          style={{ marginTop: '10px' }}
        >
          {!isPreview && (
            <p>
              <a
                href={`/player/reports/just-the-facts?jtfOperation=${arithmeticOperation}&jtfLevel=${jtfMode}`}
              >
                REVIEW
              </a>
            </p>
          )}
        </Flex>
      </div>
    </ModuleLayout>
  )
}
